module.exports = __webpack_public_path__ + "static/media/digitalLetter.d60bb9c7.png";